import { NewVenueStages } from "../types";



export const SET_STAGE = "SET_STAGE";

export function setStage(stage: NewVenueStages) {
    return {
        type: SET_STAGE,
        payload: stage
    }
}

export const SET_VENUE_DATA = "SET_VENUE_DATA";

export function setVenueData(venueData: any) {
    return {
        type: SET_VENUE_DATA,
        payload: venueData
    }
}

export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";


export function setSubscription(subscription: string | null) {
    return {
        type: SET_SUBSCRIPTION,
        payload: subscription
    }
}

export const SET_LEAD_ID = "SET_LEAD_ID";

export function setLeadId(leadId: string) {
    return {
        type: SET_LEAD_ID,
        payload: leadId
    }
}

export const SET_HUBSPOT_ID = "SET_HUBSPOT_ID";

export function setHubspotId(hubspotId: string) {
    return {
        type: SET_HUBSPOT_ID,
        payload: hubspotId
    }
}